const messages = require('./de.json');
const xingMessages = require('./xing/de.json');

module.exports = {
  locales: ['de'],
  messages: { ...xingMessages,...messages },
};
